import React, { useEffect, useState } from "react";
import InputGroup from "../../../UI/Inputs/InputGroup";
import {
  getAllCoursesSimpleList,
  getSimpleCourseRequest,
} from "../../../../requests/courses";
import SearchAsync from "../../../UI/SearchAsync";

const groupByPriority = (courses) => {
  return [
    {
      options: courses.filter((course) => course.priority),
    },
    {
      options: courses.filter((course) => !course.priority),
    },
  ];
};

export default function CourseSelect({ onChange, selectedCourseId }) {
  const [defaultValue, setDefaultValue] = useState(null);

  const loadOptions = async (inputValue) => {
    const res = await getAllCoursesSimpleList();

    const courses = res.data.courses
      .filter((course) =>
        course.name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((course) => ({
        label: `${course.name}`,
        value: course.id,
        priority: course.priority,
      }));

    return groupByPriority(courses);
  };

  const fetchCourse = async (courseId) => {
    const res = await getSimpleCourseRequest(courseId);
    return res.data;
  };

  const handleChange = async (selected) => {
    onChange(null);
    const course = await fetchCourse(selected.value);
    onChange(course);
  };

  useEffect(() => {
    if (selectedCourseId) {
      const loadCourse = async () => {
        const course = await fetchCourse(selectedCourseId);

        const defaultOption = {
          label: `${course.name}`,
          value: course.id,
        };

        setDefaultValue(defaultOption);
      };

      loadCourse();
    }
  }, [selectedCourseId]);

  return (
    <div className="lg:w-1/2 m-auto min-h-[320px]">
      <label>Course</label>
      <InputGroup>
        <SearchAsync
          loadOptions={loadOptions}
          onChange={handleChange}
          placeholder="Search for a course"
          className="border rounded"
          defaultValue={defaultValue}
        />
      </InputGroup>
    </div>
  );
}
